<p class="section-description">
  The production Account Settings → Retention Policy screen. Retention settings, the protected recovery-point list, and
  the account-id stream are all stubbed, so the
  <strong>Indefinitely-Retained Recovery Points</strong> table renders even on accounts without
  <code>allowProtectRecoveryPoint</code> or any protected recovery points. Selection and Release are live against the
  mock list — releasing every row empties the table, exactly as production would.
</p>
<div class="retention-actions">
  <button class="arpio-secondary-button" (click)="resetRetentionMocks()">Reset mock data</button>
</div>
<div class="retention-screen-frame">
  @if (retentionMounted) {
    <app-account-retention-policy></app-account-retention-policy>
  }
</div>
